import { useState } from 'react'

const FAQS = [
    {
        question: 'How are you different from other investor mail vendors?',
        answer: "Most investor mail vendors are print shops with a list upload form. We know how data, strategy, direct mail, and tracking work together to create campaigns that actually produce deals. That includes building the right list around your buy box, choosing the right format and cadence, and reading the response data to make the next drop better than the last. We're also good at diagnosing underperforming investor campaigns - if you're already mailing and it's not working, we'll tell you why and what to change, whether or not you move to us.",
    },
    {
        question:
            'How is this different from EDDM or cheap bulk postcard services?',
        answer: 'EDDM mails every address on a carrier route - useful for basic awareness, but it ignores seller motivation. Cheap bulk mail services usually give you templates and low per-piece pricing, but no real list strategy, sequencing, or response tracking. We add the layer most investors are missing: motivated seller lists, custom creative, multi-touch cadence, and the data to know which drops are actually working.',
    },
    {
        question: 'How fast can you get mail out when a new list comes in?',
        answer: 'We offer 2-business-day production for most formats once the list and creative are approved. For investors running fresh lists - like new pre-foreclosures or probates - the goal is speed. We can move quickly so your mail lands while the lead is still fresh.',
    },
    {
        question: "What's the minimum spend to get started?",
        answer: "This is built for active investors running recurring campaigns, not one-off postcard orders. There's no fixed minimum, but the value shows up in a repeatable program: fresh-list speed, consistent cadence, and tracking that compounds over months. If you only need the cheapest possible per-piece mailer, we're probably not the right fit.",
    },
]

function PlusIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    )
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null)

    return (
        <section className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 lg:py-16">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        Frequently asked
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3F454F] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Questions investors ask first.
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    {FAQS.map((faq, i) => (
                        <div
                            key={i}
                            className="flex flex-col rounded-2xl border border-secondary/30 bg-white">
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenIndex(openIndex === i ? null : i)
                                }
                                className="flex w-full cursor-pointer flex-row items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left transition-colors hover:bg-secondary/[0.03]">
                                <span
                                    className="text-lg font-semibold text-[#3F454F]"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.question}
                                </span>
                                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10">
                                    <PlusIcon
                                        className={`h-4 w-4 text-secondary transition-transform duration-200 ${
                                            openIndex === i ? 'rotate-45' : ''
                                        }`}
                                    />
                                </div>
                            </button>
                            <div
                                className="overflow-hidden transition-all duration-300"
                                style={{
                                    maxHeight: openIndex === i ? '600px' : '0',
                                    opacity: openIndex === i ? 1 : 0,
                                }}>
                                <div
                                    className="px-6 pb-6 text-lg text-[#3F454F]/70"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
